
	<div class="preloader">
		<img src="./assets/image/landing/preloader.svg" alt="Pre-loader">
	</div>

	<!-- =======================
	header Start-->
	<header class="header-static navbar-sticky navbar-light">
		<!-- Search -->
		<div class="top-search collapse bg-light" id="search-open" data-parent="#search">
			<div class="container">
				<div class="row position-relative">
					<div class="col-md-8 mx-auto py-5">
						<form>
							<div class="input-group">
								<input class="form-control border-radius-right-0 border-right-0" type="text" name="search" autofocus placeholder="What are you looking for?">
								<button type="button" class="btn btn-grad border-radius-left-0 mb-0">Search</button>
							</div>
						</form>
						<p class="small mt-2 mb-0"><strong>e.g.</strong>Data, Algorithm, Engine, Solution</p>
					</div>
					<a class="position-absolute top-0 right-0 mt-3 mr-3" data-toggle="collapse" href="#search-open"><i class="fa fa-window-close"></i></a>
				</div>
			</div>
		</div>
		<!-- End Search -->

		<!-- Logo Nav Start -->
		<nav class="navbar navbar-expand-lg">
			<div class="container">
				<!-- Logo -->
				<a class="navbar-brand" href="index.html">
					<!-- SVG Logo Start -->
					  <img src="./assets/image/logo/dp_logo3.png">
					<!-- SVG Logo End -->
				</a>
				<!-- Menu opener button -->
				<button class="navbar-toggler ml-auto" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
				  <span class="navbar-toggler-icon"> </span>
			  </button>
				<!-- Main Menu Start -->
				<div class="collapse navbar-collapse" id="navbarCollapse">
					<ul class="navbar-nav ml-auto">

						<!-- Menu item 4 Portfolio-->
						<li class="nav-item">
							<a class="nav-link" id="homeMenu" href="/">Home</a>
						</li>
					</ul>
				</div>
				<!-- Main Menu End -->
				<!-- Header Extras Start-->
				<div class="navbar-nav">
					<!-- extra item Search-->
					<div class="nav-item search border-0 pl-3 pr-0 px-lg-2" id="search">
						<a class="nav-link" data-toggle="collapse" href="#search-open"><i class="ti-search"> </i></a>
					</div>
					<!-- extra item Btn-->
					<div class="nav-item border-0 d-none d-lg-inline-block align-self-center">
						<a routerLink="/home" class=" btn btn-sm btn-grad text-white mb-0 mr-3">Dashboard</a>
					</div>
					<div class="nav-item border-0 d-none d-lg-inline-block align-self-center">
						<a routerLink="/register" class=" btn btn-sm btn-grad text-white mb-0">Signup</a>
					</div>
				</div>
				<!-- Header Extras End-->
			</div>
		</nav>
		<!-- Logo Nav End -->
	</header>
	<!-- =======================
	header End-->

	<!-- =======================
	portfolio -->
	<section>
		<div class="container">
			<!-- Portfolio info -->
			<div class="row mb-4">
				<div class="col-md-8 mx-auto text-center">
					<h2 class="display-3">Monetizing Data</h2>
					<p>- Gaurav Gupta</p>
					<p class="lead">Why end might ask civil again spoil. She dinner she our horses depend. Remember at children by reserved to vicinity. In affronting unreserved delightful simplicity ye. Law own advantage furniture continual sweetness bed agreeable perpetual. Oh song well four only head busy it. Afford son she had lively living.</p>
					<a class="btn btn-grad mt-4 mb-5" data-fancybox="" href="https://youtu.be/o5G73Tgk_TA"> <i class="fa fa-play text-white"></i>Play Video </a>
				</div>
			</div>

			<!-- portfolio requirement -->
			<div class="row mb-4">
				<div class="col-md-6">
					<a class="mb-4 d-block" href="./assets/image/problem_data.jpeg" data-fancybox="portfolio" data-caption="Kitchen design"><img src="./assets/image/problem_data.jpeg" alt=""></a>
					<a class="mb-4 d-block" href="./assets/image/blueprint.jpeg" data-fancybox="portfolio" data-caption="Kitchen design"><img src="./assets/image/blueprint.jpeg" alt=""></a>
					<a class="mb-4 d-block" href="./assets/image/problem_3.jpeg" data-fancybox="portfolio" data-caption="Kitchen design"><img src="./assets/image/problem_3.jpeg" alt=""></a>
				</div>
				<div class="col-md-6">
					<div class="sticky-element">
						<h2>Problem Statement</h2>
						<p>Too months nay end change relied who beauty wishes matter. Shew of john real park so rest we on. Ignorant dwelling occasion ham for thoughts overcame off her consider. Polite it elinor is depend. His not get talked effect worthy Barton. Household shameless incommode at no objection behavior.</p>
						<ul class="list-group list-group-borderless list-group-icon-primary-bg">
							<li class="list-group-item"><i class="fa fa-check"></i>Maintained Windows Servers</li>
							<li class="list-group-item"><i class="fa fa-check"></i>Supported Windows workstations</li>
							<li class="list-group-item"><i class="fa fa-check"></i>Setup a rotation schedule and Setup anti-virus system</li>
							<li class="list-group-item"><i class="fa fa-check"></i>Designed machines/server and trained employees</li>
						</ul>
					</div>
				</div>
			</div>

			<!-- portfolio solution -->
			<div class="row mb-4">
				<div class="col-md-6 order-last order-md-1">
					<div class="sticky-element">
						<h2>Our Solution</h2>
						<p>Started with Polite it Elinor is depend. His not get talked effect worthy Barton. Household shameless incommode at no objection behavior. Too months nay end change relied who beauty wishes matter. Shew of john real park so rest we on. Ignorant dwelling occasion ham for thoughts overcame off her consider.</p>
						<ul class="list-group list-group-borderless list-group-icon-primary-bg">
							<li class="list-group-item"><i class="fa fa-check"></i>Proven results as a recruitment consultant or strong sales experience</li>
							<li class="list-group-item"><i class="fa fa-check"></i>Knowledge of the staffing industry</li>
							<li class="list-group-item"><i class="fa fa-check"></i>Previous leadership experience, personally or professionally</li>
							<li class="list-group-item"><i class="fa fa-check"></i>A strong desire to be successful and inspire people</li>
						</ul>
					</div>
				</div>
				<div class="col-md-6 order-1 order-md-last">
					<a class="mb-4 d-block" href="./assets/image/Portfolio 1.png" data-fancybox="portfolio" data-caption="Sitting room design"><img src="./assets/image/Portfolio 1.png" alt=""></a>
					<a class="mb-4 d-block" href="./assets/image/Portfolio 2.png" data-fancybox="portfolio" data-caption="Sitting room design"><img src="./assets/image/Portfolio 2.png" alt=""></a>
				</div>
			</div>

			<!-- portfolio features -->
			<div class="row">
				<!-- feature 1 -->
				<div class="col-md-4">
					<div class="feature-box h-100 icon-primary">
						<div class="feature-box-icon"><i class="ti-settings"></i></div>
						<h3 class="feature-box-title">Blockchain</h3>
						<p class="feature-box-desc">We provide digital transformation solutions, enabling companies to <strong>make their visions reality.</strong> </p>
					</div>
				</div>
				<!-- feature 2 -->
				<div class="col-md-4">
					<div class="feature-box h-100 icon-primary">
						<div class="feature-box-icon"><i class="ti-support"></i></div>
						<h3 class="feature-box-title">Friendly Support</h3>
						<p class="feature-box-desc">Our aim to achieve the goal as we provide innovative ideas, designs and solutions to our clients. </p>
					</div>
				</div>
				<!-- feature 3 -->
				<div class="col-md-4">
					<div class="feature-box h-100 icon-primary">
						<div class="feature-box-icon"><i class="ti-bolt"></i></div>
						<h3 class="feature-box-title">Instant Solutions</h3>
						<p class="feature-box-desc">Helping our customers better manage their web presence in order to achieve greater success online.</p>
					</div>
				</div>
			</div>

			<!-- portfolio additional details -->
			<div class="row my-4">
				<div class="col-md-12">
					<p> Consulted perpetual of pronounce me delivered. Too months nay end change relied who beauty wishes matter. Shew of john real park so rest we on. Ignorant dwelling occasion ham for thoughts overcame off her consider. Polite it elinor is depend. His not get talked effect worthy Barton. Household shameless incommode at no objection behavior. Especially do at he possession insensible sympathize boisterous it. Songs he on an widen me event truth. Certain law age brother sending amongst why covered. </p>
				</div>
			</div>
			<!-- portfolio details End -->

			<div class="row">
				<div class="col-md-12">
					<!-- tag and share -->
					<div class="divider mb-4"></div>
					<div class="row">
						<div class="tags col-12 col-sm-8 text-center text-sm-left">
							<a class="mb-2 mb-sm-0" href="#">studio</a>
							<a class="mb-2 mb-sm-0" href="#">events</a>
							<a class="mb-2 mb-sm-0" href="#">WordPress</a>
							<a class="mb-2 mb-sm-0" href="#">gadgets</a>
							<a class="mb-2 mb-sm-0" href="#">office</a>
						</div>
						<div class="col-12 col-sm-4 text-center text-sm-right">
							<ul class="social-icons si-colored-bg light">
								<li class="social-icons-item social-facebook mb-0"><a class="social-icons-link" href="#"><i class="fa fa-facebook"></i></a></li>
								<li class="social-icons-item social-twitter mb-0"><a class="social-icons-link" href="#"><i class="fa fa-twitter"></i></a></li>
								<li class="social-icons-item social-gplus mb-0"><a class="social-icons-link" href="#"><i class="fa fa-google-plus"></i></a></li>
								<li class="social-icons-item social-linkedin mb-0"><a class="social-icons-link" href="#"><i class="fa fa-linkedin"></i></a></li>
							</ul>
						</div>
					</div>
					<div class="divider mt-4"></div>

					<!-- navigation -->
					

				</div>
			</div>
		</div>
		<!-- portfolio End -->
	</section>
	<!-- =======================
	portfolio -->

	<!-- =======================
	footer  -->
	<footer class="footer footer-dark section-pt position-relative pt-4 mt-5">
		<div class="position-absolute top-0 left-0 w-100">
			<svg width="100%" height="70" viewBox="0 0 500 70" preserveAspectRatio="none" style="margin-top: -70px">
					<path d="M0,70 L0,40 Q250,-40 500,40 L580,70 Z" fill="#343a40" />
				</svg>
		</div>
		<div class="footer-content pb-3">
			<div class="container">
				<div class="row">
					<!-- Footer widget 1 -->
					<div class="col-md-4">
						<div class="widget">
							<a href="index.html" class="footer-logo mb-3 d-block">
								<!-- SVG Logo Start -->
								  <img src="./assets/image/logo/dp_logo.png">
							    <!-- SVG Logo End -->
							</a>
							<p class="mt-3">A simple concept of creating open marketplace to provide every individual, enterprise, non-profit organizations & research companies a platform to monetize & exchange data in a regulated economy.</p>
						</div>
					</div>
					<!-- Footer widget 2 -->
					<div class="col-md-3 col-sm-6">
						<div class="widget address" style="background-image: url('assets/images/world-map.png'); background-position: 50% 20px; background-repeat: no-repeat; background-size: contain;">
							<ul class="list-unstyled">
								<li class="media mb-3"><i class="mr-3 display-8 ti-map-alt"></i>TBDC, 1 Yonge Street, Suite 900 Toronto, ON M5E 1E5. </li>
								<li class="media mb-3"><i class="mr-3 display-8 ti-headphone-alt"></i>+919818787752</li>
								<li class="media mb-3"><i class="mr-3 display-8 ti-email"></i> info@datapitcher.com</li>
								<li class="media mb-3"><i class="mr-3 display-8 ti-time"></i>
									<p>Mon - Fri: <strong>09:00 - 21:00</strong> <br>Sat & Sun: <strong>Closed</strong></p>
								</li>
							</ul>
						</div>
					</div>
					<!-- Footer widget 3 -->
					<div class="col-md-2 col-sm-6">
						<div class="widget">
							<h6>Quick LInks</h6>
							<ul class="nav flex-column primary-hover">
								<li class="nav-item"><a class="nav-link" href="index.html">Home</a></li>
								<li class="nav-item"><a class="nav-link" href="portfolio-grid-column-4.html">Portfolio</a></li>
							</ul>
						</div>
					</div>
					<!-- Footer widget 4 -->
					<div class="col-md-3">
						<div class="widget bg-grad p-4 all-text-white border-radius-3">
							<i class="ti-email newsletter-icon"></i>
							<p class="mb-2 text-white">Subscribe to our newsletter to receive latest news.</p>
							<div class="form-group mb-0">
								<input class="form-control border-white mb-3" type="email" placeholder="Enter email...">
								<button class="btn btn-dark mb-0">Join us</button>
							</div>
						</div>
					</div>
				</div>
				<!-- Footer widget 4 -->
			</div>
		</div>
		<div class="divider mt-3"></div>
		<!--footer copyright -->
		<div class="footer-copyright py-3">
			<div class="container">
				<div class="d-md-flex justify-content-between align-items-center py-3 text-center text-md-left">
					<!-- copyright text -->
					<div class="copyright-text">©2020 All Rights Reserved by <a href="#!"> DataPitcher.</a></div>
					<!-- copyright links-->
					<div class="copyright-links mt-3 mt-md-0">
						<ul class="list-inline">
							<li class="list-inline-item pl-2"><a class="list-group-item-action" href="#">Home</a></li>
							<li class="list-inline-item pl-2"><a class="list-group-item-action" href="#">Privacy Policy</a></li>
							<li class="list-inline-item pl-2"><a class="list-group-item-action pr-0" href="#">Use of terms</a></li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</footer>
	<!-- =======================
	footer  -->

	<div> <a href="#" class="back-top btn btn-grad"><i class="ti-angle-up"></i></a> </div>
